import * as React from "react"
import {chakra, ChakraProvider, shouldForwardProp, Stack, Text,} from "@chakra-ui/react"
import {materialTheme} from "../theme/theme";
import {isValidMotionProp, motion} from 'framer-motion';
import {Provider} from "react-redux";
import {store} from "../store";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import DashboardPage from "./dashboard/DashboardPage";
import LandingPage from "./landingPage/LandingPage";
import ProductsPage from "./dashboard/pages/Products/ProductsPage";
import CategoriesPage from "./dashboard/pages/Categories/CategoriesPage";
import {AddCategoryPage} from "./dashboard/pages/Categories/AddCategoryPage";
import {AddProductPage} from "./dashboard/pages/Products/AddProductPage";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {ProductDetailsPage} from "./dashboard/pages/Products/ProductDetails/ProductDetailsPage";
import {HomePage} from "./dashboard/pages/Home/HomePage";
import {EventsPage} from "./dashboard/pages/Events/EventsPage";
import {AddEventPage} from "./dashboard/pages/Events/AddEventPage";
import {EventDetailsPage} from "./dashboard/pages/Events/EventDetails/EventDetails";
import LotsPage from "./dashboard/pages/Lots/LotsPage";
import {AddProductLotPage} from "./dashboard/pages/Lots/AddProductLotPage";
import ImagePage from "./dashboard/pages/Images/ImagesPage";
import ProducersPage from "./dashboard/pages/Producers/ProducersPage";
import UsersPage from "./dashboard/pages/Users/UsersPage";
import {EditProducerPage} from "./dashboard/pages/Producers/EditProducerPage";
import {EditUserPage} from "./dashboard/pages/Users/EditUser";
import {OrdersAdmin} from "../components/organisms/OrdersAdmin/OrdersAdmin";
import {BaseDialog} from "../components/molecules/BaseDialog/BaseDialog";
import {BaseModal} from "../components/molecules/BaseModal/BaseModal";
import FeaturedPage from "./dashboard/pages/Featured/FeaturedPage";
import {RagDocumentsPage} from "./dashboard/pages/Products/ChatbotPage";
import AccountDeletionInfoPage from "./dashboard/pages/AccountDeletionInfoPage/AccountDeletionInfoPage";

export const ChakraBox = chakra(motion.div, {
    shouldForwardProp: (prop) => isValidMotionProp(prop) || shouldForwardProp(prop),
});

export const AnimatedText = chakra(motion.p, {
    shouldForwardProp: (prop) => isValidMotionProp(prop) || shouldForwardProp(prop),
});

export interface LoginPageProps {
    setIsSignup: () => void;
}

export const queryClient = new QueryClient()

export const App = () => {
    const isAdmin = localStorage.getItem("userType") === 'admin';
    const isLogged = !!localStorage.getItem("tokenNew");

    return <ChakraProvider theme={materialTheme}>
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <>
                    <BaseDialog/>
                    <BaseModal/>
                    <Router>
                        <Routes>
                            <Route path={"/account-deletion-info"} element={<AccountDeletionInfoPage/>}/>
                            <Route path={"/"} element={isLogged ? <DashboardPage/> : <LandingPage/>}>
                                {/*<Route path={""} element={isAdmin ? <ProductsPage/> : <HomePage/>}/>*/}
                                <Route path={""} element={<Navigate to={'products'} replace />}/>
                                <Route path={"producer/:id"} element={<HomePage/>}/>
                                <Route path={"producer/edit/:id"} element={<EditProducerPage/>}/>
                                <Route path={"producer/add"} element={<EditProducerPage/>}/>
                                <Route path={"media/*"} element={<ImagePage/>}/>
                                <Route path={"featured"} element={<FeaturedPage/>}/>
                                <Route path={"products"}>
                                    <Route path={""} element={<ProductsPage/>}/>
                                    <Route path={"search"} element={<Stack w={"100%"} h={"100%"}>
                                        <Text>Cerca</Text>
                                    </Stack>}/>
                                    <Route path={"lots"}>
                                        <Route path={""} element={<LotsPage/>}/>
                                        <Route path={"add"} element={<AddProductLotPage/>}/>
                                        <Route path={"edit/:id"} element={<AddProductLotPage/>}/>
                                    </Route>
                                    <Route path={":id"} element={<ProductDetailsPage/>}/>
                                    <Route path={"category"}>
                                        <Route path={""} element={<CategoriesPage/>}/>
                                        <Route path={"add"} element={<AddCategoryPage/>}/>
                                        <Route path={"edit/:id"} element={<AddCategoryPage/>}/>
                                    </Route>
                                    <Route path={"chatbot"} element={<RagDocumentsPage/>}/>
                                    <Route path={"create"} element={<AddProductPage/>}/>
                                    <Route path={"edit/:id"} element={<AddProductPage/>}/>
                                </Route>
                                <Route path="orders/*" element={<OrdersAdmin/>}/>
                                <Route path={"events"}>
                                    <Route path={""} element={<EventsPage/>}/>
                                    <Route path={"add"} element={<AddEventPage/>}/>
                                    <Route path={":id"} element={<EventDetailsPage/>}/>
                                    <Route path={"edit/:id"} element={<AddEventPage/>}/>
                                </Route>
                                <Route path={"news"}/>
                                <Route path={"profile"}/>
                                <Route path={"producers"} element={<ProducersPage/>}/>
                                <Route path={"users/*"} element={<UsersPage/>}/>
                                <Route path={"users/edit/:id"} element={<EditUserPage/>}/>
                                <Route path={"*"} element={<Stack w={"100%"} h={"100%"}>
                                    <Text>404 - Not found!</Text>
                                </Stack>}/>
                            </Route>
                            <Route path={"landing"} element={<LandingPage/>}/>
                        </Routes>
                    </Router>
                </>
            </Provider>
        </QueryClientProvider>
    </ChakraProvider>
};
